import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "d-flex align-items-center position-relative me-1" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-warning",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_upload"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Upload Data ")
const _hoisted_7 = {
  class: "modal fade",
  ref: "uploadModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_upload"
}
const _hoisted_8 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_9 = { class: "modal-content rounded" }
const _hoisted_10 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_11 = { class: "svg-icon svg-icon-1" }
const _hoisted_12 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-5 section-title" }, "Informasi Umum Pesanan", -1)
const _hoisted_14 = { class: "row mb-5" }
const _hoisted_15 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_16 = { class: "row px-3" }
const _hoisted_17 = { class: "col-12 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_19 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "row px-3" }
const _hoisted_22 = { class: "col-12 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Jumlah", -1)
const _hoisted_24 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row px-3" }
const _hoisted_27 = { class: "col-6 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "harga", -1)
const _hoisted_29 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "col-6 fv-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Total Pembayaran", -1)
const _hoisted_33 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_36 = { class: "row px-3" }
const _hoisted_37 = { class: "col-12 fv-row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Estimasi Cetak", -1)
const _hoisted_39 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "row px-3" }
const _hoisted_42 = { class: "col-12 fv-row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Estimasi Selesai", -1)
const _hoisted_44 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-4 px-3\"><div class=\"col-12 fv-row\"><button type=\"button\" class=\"btn btn-danger me-2\"> Batal </button><button type=\"button\" class=\"btn btn-info me-2\"> Simpan </button><button type=\"button\" class=\"btn btn-outline btn-outline-primary\"> Cetak Invoice </button></div></div>", 1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-5 section-title" }, "Proses", -1)
const _hoisted_48 = { class: "row mb-5" }
const _hoisted_49 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_50 = { class: "row px-3" }
const _hoisted_51 = { class: "col-12 fv-row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Estimasi", -1)
const _hoisted_53 = { class: "row px-3" }
const _hoisted_54 = { class: "col-12 fv-row" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Status Cetak", -1)
const _hoisted_56 = { class: "row px-3" }
const _hoisted_57 = { class: "col-4 fv-row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Ekspedisi", -1)
const _hoisted_59 = { class: "col-4 fv-row" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Nomor Ekspedisi", -1)
const _hoisted_61 = { class: "col-4 fv-row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Dokumen", -1)
const _hoisted_63 = { class: "row px-3" }
const _hoisted_64 = { class: "col-12 fv-row" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Surat jalan", -1)
const _hoisted_66 = {
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_response_upload_siswa"
}
const _hoisted_67 = { class: "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" }
const _hoisted_68 = { class: "modal-content rounded" }
const _hoisted_69 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_70 = { class: "svg-icon svg-icon-1" }
const _hoisted_71 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_72 = { class: "d-flex flex-column mb-2 fv-row" }
const _hoisted_73 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_74 = { class: "d-flex flex-column mb-2 fv-row" }
const _hoisted_75 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_76 = { class: "d-flex flex-column fv-row" }
const _hoisted_77 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_78 = {
  key: 0,
  class: "table-responsive mt-4"
}
const _hoisted_79 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nomor Identitas"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note")
  ])
], -1)
const _hoisted_81 = { class: "text-center" }
const _hoisted_82 = { class: "text-center" }
const _hoisted_83 = { class: "text-center" }
const _hoisted_84 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
          ]),
          _hoisted_6
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.batalUpload()))
            }, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "name",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Nama Sekolah",
                      modelValue: _ctx.detail.schoolName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.schoolName) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.detail.schoolName == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.errorsMessage.errorschoolName), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "amount",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Jumlah",
                      modelValue: _ctx.detail.amount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail.amount) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.detail.amount == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.errorsMessage.erroramount), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "price",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Harga",
                      modelValue: _ctx.detail.price,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.price) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.detail.price == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.errorsMessage.errorprice), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "total",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Total",
                      modelValue: _ctx.detail.total,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detail.total) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.detail.total == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.errorsMessage.errortotal), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "startDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Estimasi Cetak",
                      modelValue: _ctx.detail.startDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.startDate) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.detail.startDate == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.errorsMessage.errorstartDate), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "endDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Estimasi Selesai",
                      modelValue: _ctx.detail.endDate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detail.endDate) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.detail.endDate == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.errorsMessage.errorendDate), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_46
              ])
            ]),
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "startDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Estimasi Cetak",
                      modelValue: _ctx.detail.startDate,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.detail.startDate) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "startDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Estimasi Cetak",
                      modelValue: _ctx.detail.startDate,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detail.startDate) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "startDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Estimasi Cetak",
                      modelValue: _ctx.detail.startDate,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.detail.startDate) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "startDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Estimasi Cetak",
                      modelValue: _ctx.detail.startDate,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.detail.startDate) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_Field, {
                      type: "file",
                      name: "startDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Estimasi Cetak",
                      modelValue: _ctx.detail.startDate,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.detail.startDate) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "startDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Estimasi Cetak",
                      modelValue: _ctx.detail.startDate,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.detail.startDate) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.kembaliSiswa()))
            }, [
              _createElementVNode("span", _hoisted_70, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("label", _hoisted_73, [
                _createElementVNode("span", null, "Total Siswa = " + _toDisplayString(_ctx.items.total), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("label", _hoisted_75, [
                _createElementVNode("span", null, "Data Siswa Valid = " + _toDisplayString(_ctx.items.valid), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("label", _hoisted_77, [
                _createElementVNode("span", null, "Data Siswa Tidak Valid = " + _toDisplayString(_ctx.items.unValid), 1)
              ])
            ]),
            (_ctx.items.unValidData.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  _createElementVNode("table", _hoisted_79, [
                    _hoisted_80,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.unValidData, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_81, _toDisplayString(item.identityNumber), 1),
                          _createElementVNode("td", _hoisted_82, _toDisplayString(item.name), 1),
                          _createElementVNode("td", _hoisted_83, _toDisplayString(item.note), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger me-3",
              "data-bs-dismiss": "modal",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.kembaliSiswa()))
            }, " Kembali ")
          ])
        ])
      ])
    ])
  ], 64))
}